import * as i1 from '@angular/common/http';
import { provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule, EventEmitter, Directive, Input, Output } from '@angular/core';
import { throwError } from 'rxjs';
import { share, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import * as moment from 'moment';
const API_CONFIG = new InjectionToken('ApiConfig');
let WidgetsService = /*#__PURE__*/(() => {
  class WidgetsService {
    constructor(apiConfig, http) {
      this.apiConfig = apiConfig;
      this.http = http;
    }
    dataBatched(widgetConfigs) {
      if (this.apiConfig && this.apiConfig.api) {
        return this.http.post(this.apiConfig.api + '/widget/dataBatched', {
          widgets: widgetConfigs
        }).pipe(share(), map(r => r.data));
      } else {
        return throwError('no api config');
      }
    }
    static {
      this.ɵfac = function WidgetsService_Factory(t) {
        return new (t || WidgetsService)(i0.ɵɵinject(API_CONFIG), i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WidgetsService,
        factory: WidgetsService.ɵfac
      });
    }
  }
  return WidgetsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InjectorInstance;
let GtdNgWidgetModule = /*#__PURE__*/(() => {
  class GtdNgWidgetModule {
    constructor(injector) {
      this.injector = injector;
      InjectorInstance = this.injector;
    }
    static forRoot(apiConfig) {
      return {
        ngModule: GtdNgWidgetModule,
        providers: [WidgetsService, {
          provide: API_CONFIG,
          useValue: apiConfig
        }]
      };
    }
    static {
      this.ɵfac = function GtdNgWidgetModule_Factory(t) {
        return new (t || GtdNgWidgetModule)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: GtdNgWidgetModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideHttpClient(withInterceptorsFromDi())],
        imports: [CommonModule]
      });
    }
  }
  return GtdNgWidgetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DataService = /*#__PURE__*/(() => {
  class DataService {
    constructor() {
      this.http = InjectorInstance.get(HttpClient);
      this.apiConfig = InjectorInstance.get(API_CONFIG);
    }
    data(dataConfig) {
      if (this.apiConfig && this.apiConfig.api) {
        return this.http.post(this.apiConfig.api + '/widget/data', dataConfig).pipe(share(), map(r => r.data));
      } else {
        return throwError('no api config');
      }
    }
    static {
      this.ɵfac = function DataService_Factory(t) {
        return new (t || DataService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DataService,
        factory: DataService.ɵfac
      });
    }
  }
  return DataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line
let GtdNgWidgetComponentAbstract = /*#__PURE__*/(() => {
  class GtdNgWidgetComponentAbstract {
    constructor() {
      this.autoInit = false;
      this.settings = {};
      this.dates = {
        from: moment.utc().startOf('month'),
        to: moment.utc().endOf('day')
      };
      this.options = {};
      this.selectedOption = {};
      this.dataError = new EventEmitter();
      this.dataLoaded = new EventEmitter();
      this.isLoadingValue = true;
      this.widgetDataService = new DataService();
    }
    getKey() {
      return this.key;
    }
    getSettings() {
      return {
        ...this.settings,
        ...this.selectedOption
      };
    }
    getDates() {
      return this.dates;
    }
    getConfig() {
      return {
        widget: this.getKey(),
        settings: this.getSettings(),
        from: this.getDates().from.toISOString(),
        to: this.getDates().to.toISOString()
      };
    }
    get isLoading() {
      return this.isLoadingValue;
    }
    setIsLoading(isLoading) {
      this.isLoadingValue = isLoading;
    }
    getData() {
      this.dataSubscriber?.unsubscribe();
      this.setIsLoading(true);
      this.dataSubscriber = this.widgetDataService.data(this.getConfig()).subscribe(data => {
        this.data = this.data.fromJson(data);
        this.setIsLoading(false);
        this.afterData();
        this.dataLoaded.emit(this.data);
      }, error => {
        if (this.dataError) {
          this.dataError.emit(error);
        }
        this.errorCb(error);
      });
    }
    setData(data) {
      this.data = this.data.fromJson(data);
      this.dataLoaded.emit(this.data);
    }
    afterData() {}
    errorCb(error) {}
    ngOnDestroy() {
      if (this.dataSubscriber) {
        this.dataSubscriber.unsubscribe();
      }
    }
    ngAfterViewInit() {
      if (this.autoInit) {
        this.getData();
      }
    }
    trackByFn(index) {
      return index;
    }
    trackByIdFn(index, item) {
      return item.id;
    }
    changeSelectedOption(selectedOption) {
      this.selectedOption = selectedOption;
      this.getData();
    }
    static {
      this.ɵfac = function GtdNgWidgetComponentAbstract_Factory(t) {
        return new (t || GtdNgWidgetComponentAbstract)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: GtdNgWidgetComponentAbstract,
        inputs: {
          autoInit: "autoInit",
          settings: "settings",
          dates: "dates",
          options: "options",
          selectedOption: "selectedOption"
        },
        outputs: {
          dataError: "dataError",
          dataLoaded: "dataLoaded"
        }
      });
    }
  }
  return GtdNgWidgetComponentAbstract;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TypeResponse {
  fromJson(json) {
    const object = Object.assign(this, json);
    object.dates = new Dates(json?.dates?.from * 1000, json?.dates?.to * 1000);
    return object;
  }
}
class Dates {
  constructor(from, to) {
    this.from = from;
    this.to = to;
  }
}

/*
 * Public API Surface of gtd-ng-table
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Dates, GtdNgWidgetComponentAbstract, GtdNgWidgetModule, InjectorInstance, TypeResponse, WidgetsService };
